module.exports = __webpack_public_path__ + "img/speaker_phone.7d578cc8.svg";